import React, { useEffect } from 'react';
import { publishCounterMetric } from '../utils/metrics';
import { ReInventLandingPage } from '../components/CustomContent/ReInvent23/ReInventLandingPage';

const LandingPage = () => {
  useEffect(() => {
    publishCounterMetric('LandingPage');
  }, []);
  return <ReInventLandingPage />;
};

export default LandingPage;
